/**出入库管理路由 */
export default {
    name: 'goods',
    path: 'goods',
    meta: { title: '出入库管理' },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'goods-deliver',
            path: 'deliver',
            meta: { title: '出库' },
            component: () => import('@/pages/goods/deliver.vue')
        },
        {
            name: 'goods-return',
            path: 'return',
            meta: { title: '入库' },
            component: () => import('@/pages/goods/return.vue')
        },
        {
            name: 'goods-bank',
            path: 'bank',
            meta: { title: '销售出入库' },
            component: () => import('@/pages/goods/bank.vue')
        },
        {
            name: 'goods-process',
            path: 'process',
            meta: { title: '流程和物流记录' },
            component: () => import('@/pages/goods/process.vue')
        }
    ]

}